import {
    // eslint-disable-next-line camelcase
    OVB_Blau, OVB_Himbeer, OVB_Purpur, OVB_Sonne,
} from '../modules/Color';

// eslint-disable-next-line import/prefer-default-export
export const ovbColors = {
    primary: OVB_Blau,
    secondary: OVB_Sonne,
    background: '#d9e0e7',
    accent: OVB_Blau,
    error: OVB_Himbeer,
    success: OVB_Purpur,
    navbarActiveColor: OVB_Blau,
    navbarTextColor: OVB_Blau,
    navBackButtonColor: OVB_Sonne,
    navBackButtonTextColor: OVB_Blau,
    navNextButtonColor: OVB_Blau,
    navNextButtonTextColor: '#fff',
    tileActiveColor: OVB_Sonne,
    tileActiveTextColor: OVB_Blau,
    tileColor: OVB_Blau,
    tileTextColor: '#fff',
    activeTextColor: null,
    offsetCardHeaderColor: OVB_Blau,
    offsetCardHeaderTextColor: '#fff',
    helpColor: OVB_Sonne,
    helpTextColor: OVB_Blau,
    activeHelpColor: OVB_Blau,
    activeHelpTextColor: '#fff',
    primaryButtonColor: OVB_Sonne,
    primaryButtonTextColor: OVB_Blau,
    secondaryButtonColor: OVB_Blau,
    secondaryButtonTextColor: '#fff',
    actionButtonColor: null,
    actionButtonText: null,
    priceBoxColor: OVB_Sonne,
    priceBoxActiveColor: null,
    priceBoxTextColor: OVB_Blau,
    priceBoxActiveTextColor: '#fff',
};
